import React, { useState, useCallback } from "react";
import { ToastMessage } from "../../../global/ToastMessage";
import { FPagoStyleStyle, FPagoButonStyleStyle } from "./FPagoStyles";
import { Button, Grid } from "@material-ui/core";
import { useDispatch } from "react-redux";
import { newPagoMasivoAction } from "./../../../ducks/pagosMasivosDuck";
import HeaderModal from "../../../global/headerModal";
import BackDrop from "./../../../global/BackDrop";
import ModalBase from "./../../../global/ModalBase";
import UploadInput from "./../../../global/UploadInput";
import { getBase64 } from "./../../../utils/fileBase64";
const useToggle = (initialState = false) => {
  const [state, setState] = useState(initialState);
  const toggle = useCallback(() => setState((state) => !state), []);
  return [state, toggle];
};

const BotonPago = (props) => {
  const [isOpen, setIsOpen] = useToggle();
  const classButton = FPagoButonStyleStyle();
  return (
    <div className={classButton.flexEnd}>
      <Button variant="outlined" color="primary" onClick={setIsOpen}>
          Nuevo Archivo
      </Button>
      <FPago open={isOpen} setOpen={setIsOpen} />
    </div>
  );
};

const FPago = (props) => {
  const { open = true, setOpen = () => {} } = props;

  const dispatch = useDispatch();
  const classes = FPagoStyleStyle();
  const [isLoad, setIsLoad] = useState(false);
  const [file, setFile] = useState([]);
  const [message, setMessage] = useState("");
  const onSave = () => {
    if (file.length > 0) {
      setIsLoad(true);
      setMessage("Esto puede tardar varios minutos...");
      file.forEach(async (archivo) => {
        await getBase64(archivo).then((result) => {
          const Logobase64 = String(result).split(",")[1];
          let payload = {
            ArchivoBase64: Logobase64,
            ArchivoBase64Extencion: archivo.name.split(".")[archivo.name.split(".").length - 1],
          };
          dispatch(newPagoMasivoAction(payload)).then((Response) =>{
            switch (Response.status) {
              case 400:
                ToastMessage.fire({
                  icon: "warning",
                  title: "<strong>Atención</strong>",
                  text: Response.Message ? `${Response.Message}` : `Ocurrio un problema inesperado`,
                });
                break;
              case 500:
                ToastMessage.fire({
                  icon: "error",
                  title: Response.Message ? `${Response.Message}` : `Ha habido un problema de conexión con el servidor`,
                });
                break;
                default:
                  handleClose();
                  ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                  });
                  break;
            }
            setIsLoad(false);
            setMessage("");
          })
        })
      })
    }else {
      ToastMessage.fire({
        icon: "warning",
        title: "<strong>Atención</strong>",
        text: "No se ha adjuntado algun archivo valido.",
      });
    }
  };
  const LimpiarForm = () => {
    setFile([]);
  };
  const handleClose = () => {
    setOpen();
    LimpiarForm();
  };
  return (
    <ModalBase classes={classes} open={open} onClose={handleClose}>
      <HeaderModal handleClose={handleClose} titulo={`Cargar archivo`} />
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12}>
          <UploadInput files={file} setFiles={setFile} isPreview={false} multiple={false} accept=".txt"/>
          </Grid>
        </Grid>
        <Grid container className={classes.containerSpacing}>
          <Grid item xs={12} className={classes.modalBotonesCenter}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              onClick={onSave}
              className={classes.modalBoton}
            >
              {"Aplicar"}
            </Button>
          </Grid>
        </Grid>
        <BackDrop open={isLoad} message={message} />
    </ModalBase>
  );
};
export default BotonPago;
